import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import colors from 'styles/colors';
import media from 'styles/media';
import sizes from 'styles/sizes';
import IconButton from 'components/buttons/IconButton';
import HamburguerIcon from 'components/svg/HamburgerIcon';
import PhoneIcon from 'components/svg/Phone';
import MenuList from 'components/MenuList';
import MenuUserOptions from 'components/MenuUserOptions';
import { url } from 'components/Footer/constants';
import { CruiseSearchContext } from 'contexts/CruiseSearchContext';
import { useFeatureFlags } from '../../hooks/LaunchDarkly/useFeatureFlags';

const Nav = styled.nav`
	height: 80px;
	position: sticky;
	top: 0;
	background-color: ${colors.functional.blue};
	letter-spacing: 2px;
	margin: 0 ${sizes.gutter.large}px 20px;
	display: flex;
	align-items: center;
	text-transform: uppercase;

	.headerMenu {
		flex: 1;
		justify-content: space-between;

		li {
			display: flex;
			align-items: center;
			padding: 0 21px;

			&:first-child {
				padding-left: 0;
			}
		}

		a {
			color: ${colors.primary.ice};
			font-size: 14px;
		}
	}

	.iconButton {
		padding-right: 20px;

		${media.medium`
      padding-right: 0;
    `}
	}

	${media.medium`
    height: 60px;
    justify-content: space-between;
    margin: 0 0 20px;
    padding: 0 32px;
  `}

	${media.small`
    padding: 0 16px;
  `}
`;

const BrandLink = styled.a`
	display: block;
	height: 44px;
	margin: 0 39px 0 18px;
	width: 156px;

	${media.medium`
    display: none;
  `}
`;

const BrandSmallLink = styled.a`
	display: none;
	width: 33px;

	${media.medium`
    display: block;
    height: 36px;
  `}
`;

const MobilePhoneIconLink = styled.a`
	display: none;

	${media.medium`
    display: block;
    width: 24px;
    height: 42px;
  `}
`;

export const Logo = styled.img`
	height: 44px;
	width: 156px;
`;

export const LogoSmall = styled.img`
	height: 36px;
	width: 33px;
`;

/**
 * Placeholder for the real menu
 *
 * @param {array} storybookMenu array of objects, remove this when service is working
 * @param {func} onClick
 */

function MainMenu({ storybookMenu, onClick }) {
	const { locale, universalNavigation } = useContext(CruiseSearchContext);
	const { phoneNumber } = locale;
	const { showUserFavoritesFeature, showUserWatchlistFeature } = useFeatureFlags();

	const navigationMainHeader = storybookMenu || universalNavigation?.components.header.mainMenu;

	return (
		<Nav id="rciHeader">
			<IconButton className="iconButton" onClick={onClick} icon={<HamburguerIcon color={colors.primary.ice} />} />
			<BrandLink href={`${locale.path}?country=${locale.country}`}>
				<Logo src={`${url}/content/dam/royal/resources/icons/logo/royal-caribbean-logo-no-border.svg`} alt="Royal Caribbean" />
			</BrandLink>
			<BrandSmallLink href={`${locale.path}?country=${locale.country}`}>
				<LogoSmall src={`${url}/content/dam/royal/resources/icons/logo/royal-caribbean-logo-crown-anchor.svg`} alt="Royal Caribbean" />
			</BrandSmallLink>
			<MenuList className="headerMenu" menuItems={navigationMainHeader} inline />
			<MenuUserOptions toggleFavorite={showUserFavoritesFeature} toggleWatchlist={showUserWatchlistFeature} />
			<MobilePhoneIconLink href={`tel:${phoneNumber}`}>
				<PhoneIcon />
			</MobilePhoneIconLink>
		</Nav>
	);
}

MainMenu.propTypes = {
	storybookMenu: PropTypes.array,
	onClick: PropTypes.func,
};

export default MainMenu;
